import { useEffect } from "react";
// Та же карточка, что у заглушки «только на телефоне» (PhoneOnly). Та — в
// отдельном куске сборки, а этот экран показывают как раз без сети, когда
// догрузить ничего нельзя: стили должны быть в основном.
import "./phone-only.css";

// Мобильная версия открылась, а сервер не ответил (нет сети, метро, выкатка).
// Форма входа тут соврала бы — пользователь уже вошёл. Повторяем сами: когда
// телефон снова в сети и раз в 10 секунд.
export function Unreachable({ onRetry }: { onRetry: () => void }) {
  useEffect(() => {
    const timer = window.setInterval(onRetry, 10_000);
    window.addEventListener("online", onRetry);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("online", onRetry);
    };
  }, [onRetry]);
  return (
    <div className="m-only">
      <div className="m-only-card">
        <div className="m-only-brand">
          <span className="m-only-logo">H</span>
          <span>HRDeva</span>
        </div>
        <h1>Нет связи с сервером</h1>
        <p>Проверьте интернет. Как только связь появится, чаты откроются сами.</p>
        <button type="button" className="btn-primary m-only-go" onClick={onRetry}>
          Повторить
        </button>
      </div>
    </div>
  );
}
